// extracted by mini-css-extract-plugin
module.exports = {"w152gtxt":"w152gtxt","fadeIn":"fadeIn","t12tipu7":"t12tipu7","t1brx004":"t1brx004"};